import { Box, Button, CircularProgress, Grid, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import BasicDatePicker from "../../../../../../../components/BasicDatePicker";
import { formatarInputValorMonetário, permitirApenasNumeros } from "../../../../../../../helpers/masks";
import SelectPlanoContas from "../../../../../../../components/SelectsSimpleApiQuery/SelectPlanoContas";
import SelectLojaComPesquisa, { TLoja } from "../../../../../../../components/SelectsSimpleApiQuery/SelectLojaComPesquisa";
import SelectCentroCusto from "../../../../../../../components/SelectsSimpleApiQuery/SelectCentroCusto";

export default function Step02() {

  const { getValues, control, handleSubmit, watch, setValue } = useFormContext()

  const onSubmit = getValues('funcoesAux.onSubmit')
  const handleBackStep = getValues('funcoesAux.onBack')
  const isLoading = watch('isLoadingCheque')
  const praca = watch('step02.praca')
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 6 }}>
        <Controller
          name="step02.loja"
          rules={{ required: 'Campo obrigatório' }}
          control={control}
          render={({ field, fieldState: { error, invalid } }) => (
            <SelectLojaComPesquisa
              value={field.value}
              required
              error={invalid}
              errorMessage={error?.message}
              onChange={(value) => {
                const valor = value as TLoja
                field.onChange(valor)
                if (praca === '') {
                  setValue('step02.praca', valor?.cidade)
                }
              }}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Controller
          name="step02.lote"
          rules={{ required: 'Campo obrigatório' }}
          control={control}
          render={({ field, fieldState: { error, invalid } }) => (
            <TextField
              label="Lote"
              value={field.value || ''}
              required
              error={invalid}
              fullWidth
              onChange={(e) => {
                const newValue = permitirApenasNumeros(e.target.value);
                field.onChange(newValue)
              }}
              slotProps={{ htmlInput: { maxLength: 6 } }}
              helperText={invalid ? error?.message : ""}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Controller
          name="step02.data_origem"
          control={control}
          rules={{ required: 'Campo obrigatório' }}
          render={({ field, fieldState: { error, invalid } }) => (
            <BasicDatePicker
              label="Origem *"
              helperText={error ? error.message : ""}
              error={invalid}
              value={field.value}
              onChange={(data) => field.onChange(data)}
              formatString="DD/MM/YYYY"
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Controller
          name="step02.valor"
          control={control}
          rules={{ required: 'Campo obrigatório' }}
          render={({ field, fieldState: { error, invalid } }) => (
            <TextField
              label="Valor"
              required
              fullWidth
              error={invalid}
              helperText={error ? error.message : ""}
              value={field.value}
              onChange={(e) => {
                const formattedValue = formatarInputValorMonetário(e.target.value)
                field.onChange(formattedValue)
              }}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <Controller
          name="step02.conta_devedora"
          control={control}
          rules={{ required: 'Campo obrigatório' }}
          render={({ field, fieldState: { invalid } }) => (
            <SelectPlanoContas
              inputLabel="Conta devedora"
              value={field.value}
              required
              error={invalid}
              onChangeValue={(valor) => field.onChange(valor)}
              extraParams={{ sistema_xy: "D-CHE" }}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <Controller
          name="step02.contra_partida"
          control={control}
          rules={{ required: 'Campo obrigatório' }}
          render={({ field, fieldState: { invalid } }) => (
            <SelectPlanoContas
              inputLabel="Contra partida"
              value={field.value}
              required
              error={invalid}
              onChangeValue={(valor) => field.onChange(valor)}
              extraParams={{ tipo: "Analítica" }}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <Controller
          name="step02.departamento_centro_custo"
          control={control}
          rules={{ required: 'Campo obrigatório' }}
          render={({ field, fieldState: { invalid } }) => (
            <SelectCentroCusto
              value={field.value}
              required
              error={invalid}
              onChange={(valor) => field.onChange(valor)}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Controller
          name="step02.praca"
          control={control}
          render={({ field, fieldState: { invalid, error } }) => (
            <TextField
              label="Praça"
              value={field.value || ''}
              error={invalid}
              fullWidth
              onChange={(e) => { field.onChange(e) }}
              slotProps={{ htmlInput: { maxLength: 20 } }}
              helperText={invalid ? error?.message : ""}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Controller
          name="step02.data_vencimento"
          control={control}
          rules={{ required: 'Campo obrigatório' }}
          render={({ field, fieldState: { error, invalid } }) => (
            <BasicDatePicker
              label="Vencimento *"
              helperText={error ? error.message : ""}
              error={invalid}
              value={field.value}
              onChange={(data) => field.onChange(data)}
              formatString="DD/MM/YYYY"
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Box display={'flex'} gap={2}>
          <Button
            variant="outlined"
            onClick={handleBackStep}
            disabled={isLoading}
          >
            Voltar
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit(onSubmit)}
            disabled={isLoading}
          >
            {
              isLoading &&
              <CircularProgress size={20} sx={{ marginRight: 1 }} />
            }
            Finalizar
          </Button>
        </Box>
      </Grid>
    </Grid>
  )
}
